import {
  PONTO_VENDA_FAIL,
  PONTO_VENDA_LOADING,
  PONTO_VENDA_SUCCESS,
  PONTO_VENDA_FILTER,
  PontoVendaDispatchTypes,
  PontoVenda,
  FilterPontosVenda,
} from '../actions/PontoVendaTypes';

interface DefaultState {
  loading: boolean;
  error?: string;
  pontosVendaData: PontoVenda[];
  filterData: FilterPontosVenda;
};

const defaultState: DefaultState = {
  pontosVendaData: [],
  loading: false,
  error: '',
  filterData: {
    filter: '',
    type: 'N',
  },
};

const pontosVendaReducer = (
  state: DefaultState = defaultState,
  action: PontoVendaDispatchTypes,
): DefaultState => {
  switch (action.type) {
    case PONTO_VENDA_FAIL:
      return {
        ...state,
        pontosVendaData: [],
        loading: false,
        error: action.payload,
      };
    case PONTO_VENDA_LOADING:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case PONTO_VENDA_SUCCESS:
      return {
        ...state,
        loading: false,
        pontosVendaData: action.payload,
      };
    case PONTO_VENDA_FILTER:
      return {
        ...state,
        filterData: action.payload,
      };
    default:
      return state;
  }
};

export default pontosVendaReducer;
